import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

// Loop through the process steps in redux state and output them, giving the active
// step the active class

export const ProgressBarComponent = (props) => {
  return (
    props.show && (
      <div className="app-progress-bar">
        {props.processSteps.steps.map((step, index) => {
          return (
            <div
              className={
                props.processSteps.currentStep === step.id
                  ? "step active"
                  : step.id < props.processSteps.currentStep
                  ? "step completed"
                  : "step"
              }
              key={step.description}
            >
              <strong> {`0${step.id}`} </strong>
              {`${step.description}`}
            </div>
          );
        })}
      </div>
    )
  );
};

// Map global store to component props
const mapStateToProps = (state) => state;

// Hook up actions to component
const mapDispatchToProps = {};

//Connect to Redux store
const ProgressBar = withRouter(connect(mapStateToProps, mapDispatchToProps)(ProgressBarComponent));

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/progress-bar/progress-bar.component.js